module.exports = __webpack_public_path__ + "static/media/made-in-usa-grey.eade5e21.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/maker/made-in-usa-grey.svg
 ** module id = 468
 ** module chunks = 0
 **/